<template>
    <header class="nav_buttons">
        <slot></slot>
    </header>
</template>

<script>
    export default {
        name: "Nav"
    }
</script>

<style scoped>
.nav_buttons {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: fixed;
    top: 2%;
    right: 5%;
    z-index: 999;
    height: 110px;

}
</style>